import type * as React from 'react';
import type { AssetMediaType, AssetScope } from './types';

export const GALLERY_PAGE_SIZE = 12;

export const SCOPE_OPTIONS: { key: AssetScope; label: string }[] = [
  { key: 'my', label: '我的' },
  { key: 'space', label: '空间共享' },
  { key: 'system', label: '系统共享' },
];

export const MEDIA_TYPE_OPTIONS: { key: AssetMediaType; label: string }[] = [
  { key: 'image', label: '图片' },
  { key: 'audio', label: '音频' },
  { key: 'video', label: '视频' },
  { key: 'document', label: '文档' },
];

export const MEDIA_TYPE_SEARCH_PLACEHOLDER: Record<AssetMediaType, string> = {
  image: '搜索图片',
  audio: '搜索音频',
  video: '搜索视频',
  document: '搜索文档',
};

export const MEDIA_TYPE_ACCEPT: Record<AssetMediaType, string> = {
  image: 'image/*',
  audio: 'audio/*',
  video: 'video/*',
  document: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv',
};

export const checkerboardStyle: React.CSSProperties = {
  backgroundColor: '#e5e5e5',
  backgroundImage: [
    'linear-gradient(45deg, #d4d4d4 25%, transparent 5%)',
    'linear-gradient(-45deg, #d4d4d4 25%, transparent 5%)',
    'linear-gradient(45deg, transparent 75%, #d4d4d4 75%)',
    'linear-gradient(-45deg, transparent 75%, #d4d4d4 75%)',
  ].join(', '),
  backgroundSize: '8px 8px',
  backgroundPosition: '0 0, 0 4px, 4px -4px, -4px 0px',
};

/** 与 `SelectMyImage` 一致：按容器宽度计算 Masonry 列数 */
export function masonryColumnsForContainerWidth(width: number): number {
  if (width < 1) return 1;
  if (width >= 720) return 4;
  if (width >= 520) return 3;
  if (width >= 380) return 2;
  return 1;
}
